import { Box } from "@mui/material"
import { AddOutlined, LinkRounded } from "@mui-symbols-material/w300"
import type { FC } from "react"

import { Button } from "@/components/common/Button"
import { PermissionActionType } from "@/constants/permissions"
import { usePermissionManager } from "@/hooks/usePermissionManager"
import { CompanyProductsFilterChips } from "@/screens/Companies/products/CompanyProductsFilterChips"
import { ProductSearchBar } from "@/screens/Companies/products/ProductSearchBar"

interface CompanyProductsSearchBarProps {
  shouldShowProductSearchBar: boolean
  toggleFilterDrawer: () => void
  onStartPo: () => void
  onNewProduct: () => void
  isStartPoDisabled: boolean

  isCustomerCompanyType: boolean
}

const CompanyProductsSearchBar: FC<CompanyProductsSearchBarProps> = ({
  shouldShowProductSearchBar,
  toggleFilterDrawer,
  onStartPo,
  onNewProduct,
  isStartPoDisabled,

  isCustomerCompanyType,
}) => {
  const { hasPermissions } = usePermissionManager()
  const hasPurchaseOrderCreationPermission = hasPermissions([PermissionActionType.PURCHASE_ORDER_CREATION])
  const VendorSearchBar = shouldShowProductSearchBar ? (
    <Box className='flex justify-between'>
      <ProductSearchBar onShowFilter={toggleFilterDrawer} />
      <Box className='flex items-center gap-2'>
        {hasPurchaseOrderCreationPermission && (
          <Button
            appearance='outlined'
            variant='primary'
            startIcon={<AddOutlined />}
            onClick={onStartPo}
            disabled={isStartPoDisabled}
          >
            Start PO
          </Button>
        )}
        <Button appearance='outlined' variant='primary' startIcon={<AddOutlined />} onClick={onNewProduct}>
          New Product
        </Button>
      </Box>
    </Box>
  ) : (
    <Box className='flex justify-end'>
      <Button appearance='outlined' variant='primary' startIcon={<AddOutlined />} onClick={onNewProduct}>
        New Product
      </Button>
    </Box>
  )

  const CustomerSearchBar = (
    <Box className='flex justify-between'>
      <ProductSearchBar onShowFilter={toggleFilterDrawer} />
      <Box className='flex items-center gap-2'>
        <Button appearance='outlined' variant='primary' startIcon={<LinkRounded />} onClick={onNewProduct}>
          Associate Product
        </Button>

        <Button
          appearance='outlined'
          variant='primary'
          startIcon={<AddOutlined />}
          onClick={onStartPo}
          disabled={isStartPoDisabled}
        >
          Start PO
        </Button>
      </Box>
    </Box>
  )

  return (
    <>
      {isCustomerCompanyType ? CustomerSearchBar : VendorSearchBar}

      <CompanyProductsFilterChips />
    </>
  )
}

export default CompanyProductsSearchBar
